export default {
  styleOverrides: {
    root: {
      border: 'none',
    },
  },
};
